module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/vip-star-a8cbd4052263f841fe30ee08820a8af8.svg";